/**
 * CodeBlock that preserves the fence info-string remainder (title="..", {1,3},
 * showLineNumbers, ...) which the public CodeBlock renderer relies on.
 */
import CodeBlock from '@tiptap/extension-code-block';

export const CodeBlockMeta = CodeBlock.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      meta: {
        default: '',
        parseHTML: (el) => el.querySelector('code')?.getAttribute('data-meta') || '',
        rendered: false,
      },
    };
  },

  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          const info = [node.attrs.language || '', node.attrs.meta || ''].filter(Boolean).join(' ');
          const runs = node.textContent.match(/`+/g) || [];
          const fence = '`'.repeat(Math.max(3, ...runs.map((r) => r.length + 1)));
          state.write(fence + info + '\n');
          state.text(node.textContent, false);
          state.ensureNewLine();
          state.write(fence);
          state.closeBlock(node);
        },
      },
    };
  },
});
